import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import {
  QualityMetricBox,
  getMetricAriaLabel,
} from 'src/components/quality-metric/quality-metric-box/quality-metric-box';
import styles from './metrics-sidebar.module.scss';

export function MetricSidebarItem({ metric, isSelected, trend, onSelect }) {
  const lang = useSelector(getLang('QUALITY_METRIC'));

  return (
    <button
      className={classNames(styles.item, { [styles.itemSelected]: isSelected })}
      onClick={onSelect}
      aria-label={getMetricAriaLabel({ metric, trend, lang })}
      aria-current={isSelected ? 'true' : undefined}>
      <QualityMetricBox
        metric={metric}
        trend={trend}
        showIcon={false}
        titleClassName={styles.itemTitle}
      />
    </button>
  );
}
